const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.style.setProperty('--animation-order', String(index));
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Auto-apply scroll-trigger to sections and cascade children within #MainContent
function applySectionScrollTriggers() {
  const main = document.getElementById('MainContent');
  if (!main || main.dataset.scrollAnimation !== 'true') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Apply to top-level sections (no cascade — each section reveals independently)
  const sections = main.querySelectorAll(':scope > .shopify-section');
  sections.forEach((section) => {
    if (!section.classList.contains(SCROLL_ANIMATION_TRIGGER_CLASSNAME)) {
      section.classList.add(SCROLL_ANIMATION_TRIGGER_CLASSNAME);
    }
  });

  // Built-in selectors for known grid/list item types
  applyScrollTriggerToItems(main.querySelectorAll('.product-grid__item'));
  applyScrollTriggerToItems(main.querySelectorAll('.resource-list__item'));

  // Apply scroll-trigger to elements with data-cascade (e.g., group blocks with cascade_on_scroll)
  const cascadeElements = main.querySelectorAll('[data-cascade]');
  cascadeElements.forEach((el) => {
    if (!el.classList.contains(SCROLL_ANIMATION_TRIGGER_CLASSNAME)) {
      el.classList.add(SCROLL_ANIMATION_TRIGGER_CLASSNAME);
      const siblings = Array.from(el.parentElement.children);
      el.style.setProperty('--animation-order', String(siblings.indexOf(el)));
    }
  });
}

function applyScrollTriggerToItems(items) {
  Array.from(items).forEach((item, index) => {
    if (!item.classList.contains(SCROLL_ANIMATION_TRIGGER_CLASSNAME)) {
      item.classList.add(SCROLL_ANIMATION_TRIGGER_CLASSNAME);
      item.setAttribute('data-cascade', '');
      item.style.setProperty('--animation-order', String(index));
    }
  });
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

function initAnimations() {                               
  applySectionScrollTriggers();                           
  initializeScrollAnimationTrigger();                     
  initializeScrollZoomAnimationTrigger();                  
}                                                         

if (document.readyState === 'loading') {                  
  document.addEventListener('DOMContentLoaded', initAnimations);                                             
} else {                                                  
  initAnimations();                                       
} 

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
